import React from 'react';
import { Button } from '@material-ui/core';

export default function ResetFilterButtonContainer(props) {
    return (
        <Button variant="outlined" color="secondary" onClick={props.resetFilters}>
            Reset Filters
        </Button>
    )
}